import {styled} from "@material-ui/core";

export const ViewportRoot = styled('div')(
  ({theme}) => ({padding: theme.spacing(4)}),
  {name: 'ViewportRoot'}
);
